import React from 'react';
export function HeroSection() {
  return <section className="relative w-full bg-gradient-to-br from-pink-100 via-rose-50 to-pink-200 pt-12 pb-16 px-4 overflow-hidden" data-id="element-82">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] bg-pink-300/30 rounded-full blur-[120px] pointer-events-none" data-id="element-83"></div>
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-rose-200/40 rounded-full blur-[100px] pointer-events-none" data-id="element-84"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-85">
        <h1 className="text-2xl md:text-3xl font-black uppercase tracking-tight mb-4 leading-tight text-[#881337]" data-id="element-86">
          KIT APRENDIZAJE EN CASA
        </h1>

        <h2 className="text-base md:text-lg font-medium mb-8 leading-snug max-w-2xl mx-auto text-[#E9830F]" data-id="element-87">
          Las herramientas psicopedagógicas que necesitas para comprender y
          ayudar a tu hijo
        </h2>

        <div className="relative w-full max-w-2xl mx-auto mb-8" data-id="element-88">
          <img src="https://cdn.magicpatterns.com/uploads/ttJdNWeLD9wKXKrz77WsaU/ChatGPT_Image_9_mar_2026,_12_01_05_p.m..png" alt="Kit de Aprendizaje en Casa" className="w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-89" />
        </div>

        <div className="bg-white/60 backdrop-blur-md border border-pink-200 rounded-xl p-6 mb-8 max-w-3xl mx-auto shadow-lg" data-id="element-90">
          <p className="text-lg md:text-xl font-semibold text-rose-900 mb-2" data-id="element-91">
            Descubre cómo ayudar a tu hijo cuando tiene dificultades para
            aprender, incluso si no sabes por dónde empezar.
          </p>
        </div>
      </div>
    </section>;
}